<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>

    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-bind="schema.attributesTextField"
          :disabled="schema.readonly"
          :name="schema.model"
          v-model="value"
          :rules="rules"
          :id="generateId(schema.model)"
          label="Color Picker"
          prepend-icon="mdi-palette"
          readonly
          dataInputReadonly
          v-on="on"
          @click:clear="clear"
        >
          <template v-slot:label>
            {{ schema.attributesTextField.label }}
            <span v-if="schema.rules.includes('required')" class="red--text">*</span>
          </template>
        </v-text-field>
      </template>

      <v-color-picker
        v-bind="schema.attibutesColorPicker"
        @change="onChange"
        v-model="value"
        @focus="onFocus"
      ></v-color-picker>
    </v-menu>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data: () => ({
    menu: false
  }),

  mounted() {
    this.default();
  },

  methods: {
    default() {
      setTimeout(() => {
        if (!this.value) this.value = ''
      }, 2000);
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    },

    onChange: async function () {
      this.value = this.model[this.schema.model];
      this.changeEvents();
    }
  },

  watch: {
    value(newValue, oldValue) {
      // temporary fix while there is no way to disable the alpha channel in the colorpicker component: https://github.com/vuetifyjs/vuetify/issues/9590
      if (newValue === null || (oldValue === null && newValue?.hex === '#FF0000')) {
        this.value = null;
        return;
      };
      if (typeof newValue === 'object') {
        this.value = newValue.hex;
      };
    }
}
};
</script>

<style lang="scss" scoped></style>
